// (B) 플레인 Tag — antd Tag 대체(순수 시각). `.om-tag`/`.om-tag-{status}` hook.
// 실측 소비처(EMLPreview)는 status color(success/error) + icon 사용. status 외 색은
// hex/rgb 면 인라인 배경, 그 외는 default. base/색 시각은 styles/omTag.css.
import type { CSSProperties } from 'react'
import type { OmwTagProps } from '../api/OmwTag'
import { cx } from './cx'
import '../styles/omwTag.css'

const STATUS = new Set(['success', 'processing', 'error', 'warning'])

export function PlainTag({ icon, color, className, style, children }: OmwTagProps) {
  const isStatus = color != null && STATUS.has(color)
  const isCustom = color != null && !isStatus && /^(#|rgb|hsl)/.test(color)
  const tagStyle: CSSProperties | undefined = isCustom
    ? { backgroundColor: color, borderColor: color, color: '#fff', ...style }
    : style
  return (
    <span className={cx('om-tag', isStatus && `om-tag-${color}`, className)} style={tagStyle}>
      {icon != null && <span className="om-tag-icon">{icon}</span>}
      {children}
    </span>
  )
}
